module.exports = __webpack_public_path__ + "static/media/CienciasCol.e75590d7.png";